
var countDecimals = function (value) { return value % 1?value.toString().split(".")[1].length:0; };

function Inc(obj) {
    var elem = obj.elem;
    var input = (elem.nodeName.toLowerCase() === 'input') ? true : false;
    var value = parseFloat(elem.getAttribute('data-inc-value')) || 0;
    var duration = parseInt(elem.getAttribute('data-inc-duration')) || 0;
    var delay = parseInt(elem.getAttribute('data-inc-delay')) || 0;
    var decimal = countDecimals(value);
    var suffix = obj.suffix || '';
    var speed = ((obj.speed < 30) ? 30 : obj.speed) || 30;
    var count = 0;
    var increment = value / (duration / speed);
    var interval = null;
    var regex = /\B(?=(\d{3})+(?!\d))/g;
    var run = function () {
        count += increment;
        if (count < value) {
            (input) ? elem.value = (count).toFixed(decimal).toString().replace(/[.]/, ",") + suffix : elem.innerHTML = (count).toFixed(decimal).toString().replace(/[.]/, ",") + suffix;
        } else {
            clearInterval(interval);
            (input) ? elem.value = (value).toFixed(decimal).toString().replace(/[.]/, ",")  + suffix: elem.innerHTML = (value).toFixed(decimal).toString().replace(/[.]/, ",")+ suffix;
        }
    };
    setTimeout(function () {
        interval = setInterval(run.bind(this), speed);
    }.bind(this), delay);
    this.reset = function () {
        clearInterval(interval);
        value = parseFloat(elem.getAttribute('data-inc-value')) || 0;
        duration = parseInt(elem.getAttribute('data-inc-duration')) || 0;
        increment = value / (duration / speed);
        delay = parseInt(elem.getAttribute('data-inc-delay')) || 0;
        count = 0;
        interval = setInterval(run, speed);
    }.bind(this);
}


(function ($) {
    "use strict";

    $(function () {


        const counters = document.querySelectorAll('.js-counters');

        let observer = new IntersectionObserver(entries => {
            $.each(entries, (i, entry) => {

                if (entry.intersectionRatio > 0) {
    
                    $(entry.target).find('.js-counter').each(function (i,e) {
                    
                   
                        new Inc({
                            elem: e,
                            speed: 50,
                            suffix: $(this).data('suffix')
                        })
                    });

                    observer.unobserve(entry.target);
                }
            });
        });

        $.each(counters, (i, counter) => {
            observer.observe(counter);
        });

    });
})(jQuery);